import styled from '@emotion/styled'

export const ReviewText = styled.span({
  fontSize: '.75rem',
  color: '#6f7781',
  paddingBottom: '4px',
  paddingLeft: '4px',
})

export const TimeIndicatorContainer = styled.div({
  position: 'relative',
  borderRadius: '50%',
  backgroundColor: 'hsla(0,0%,100%,.75)',
  padding: '0.25rem',
  fontWeight: '900',
  fontFamily: 'AxiformaBold,Helvetica,sans-serif',
})
